import { Home, Calendar, UserCircle, Target, BadgeDollarSign, UserCheck2Icon, BotIcon } from "lucide-react"
import { NavLink } from "react-router-dom"
import { cn } from "@/lib/utils"
import { buttonVariants } from "@/components/ui/button"

export const CorporateSidebar = () => {
  return (
    <div className="border-r bg-gray-100/40 w-[240px] h-full">
      <div className="flex flex-col gap-2 p-4">
        <NavLink
          to="/dashboard"
          className={({ isActive }) =>
            cn(
              buttonVariants({ variant: "ghost" }),
              "justify-start",
              isActive && "bg-gray-100"
            )
          }
        >
          <Home className="mr-2 h-4 w-4" />
          Dashboard
        </NavLink>
        <NavLink
          to="/dashboard/campaigns"
          className={({ isActive }) =>
            cn(
              buttonVariants({ variant: "ghost" }),
              "justify-start",
              isActive && "bg-gray-100"
            )
          }
        >
          <Target className="mr-2 h-4 w-4" />
          Campaigns
        </NavLink>
        <NavLink
          to="/dashboard/events"
          className={({ isActive }) =>
            cn(
              buttonVariants({ variant: "ghost" }),
              "justify-start",
              isActive && "bg-gray-100"
            )
          }
        >
          <Calendar className="mr-2 h-4 w-4" />
          Events
        </NavLink>
        <NavLink
          to="/dashboard/hosts"
          className={({ isActive }) =>
            cn(
              buttonVariants({ variant: "ghost" }),
              "justify-start",
              isActive && "bg-gray-100"
            )
          }
        >
          <UserCheck2Icon className="mr-2 h-4 w-4" />
          Hosts
        </NavLink>
        <NavLink
          to="/dashboard/cora"
          className={({ isActive }) =>
            cn(
              buttonVariants({ variant: "ghost" }),
              "justify-start",
              isActive && "bg-gray-100"
            )
          }
        >
          <BotIcon className="mr-2 h-4 w-4" />
          <div className="flex items-center">
            Ask Coraa
            <span className="ml-2 text-xs bg-blue-100 text-blue-800 font-medium px-1.5 py-0.5 rounded-full">BETA</span>
          </div>
        </NavLink>
        <NavLink
          to="/dashboard/profile"
          className={({ isActive }) =>
            cn(
              buttonVariants({ variant: "ghost" }),
              "justify-start",
              isActive && "bg-gray-100"
            )
          }
        >
          <UserCircle className="mr-2 h-4 w-4" />
          Profile
        </NavLink>
      </div>
    </div>
  )
}